export let masonry = {
	lists: [],
	tops: [],
	cols: 0,
	target: null,
	resize: function($target, isWedCafe){
		let hasBigCol2 	= true;
		this.target 	= $target;
		this.lists		= $target.querySelectorAll("[data-summary]");
		//console.log(this.lists);
		/*
			2カラム以上はリストの頭2つの高さを取得してからtopを決めるようにする
		*/
		if (window.matchMedia('all and (min-width : 1848px)').matches) {
			masonry.cols = 6;
			masonry.tops = [0, 0, 0, 0, 0, 0];
		}else if (window.matchMedia('all and (min-width : 1564px)').matches) {
			masonry.cols = 5;
			masonry.tops = [0, 0, 0, 0, 0];
		}else if (window.matchMedia('all and (min-width : 1280px)').matches) {
			masonry.cols = 4;
			masonry.tops = [0, 0, 0, 0];
		}else if (window.matchMedia('all and (min-width : 948px)').matches) {
			masonry.cols = 3;
			masonry.tops = [0, 0, 0];
		}else if (window.matchMedia('all and (min-width : 664px)').matches) {
			masonry.cols = 2;
			masonry.tops = [0, 0];
		}else{
			masonry.cols = 1;
			masonry.tops = [0];
		}
		let hasTag = document.querySelector("body").classList.contains("is_tag");
		if( isWedCafe || hasTag ){
			hasBigCol2 = false;
		}
		
		if(masonry.cols === 1){
			this.target.style.height = "";
			this.lists.forEach( ($l, index) => {
				$l.style.transform = ``;
			});
		}else{
			let fixTops = [0, 0];
			let maxTop 	= 0;
			if( hasBigCol2 ){
				this.lists.forEach( ($l, index) => {
					$l.classList.forEach( (className) => {
						if( className.startsWith("u-") ){
							$l.classList.remove(className);
						}
					});
					if(index < 2){
						if( masonry.cols === 2){
							fixTops[0] += $l.clientHeight;
							fixTops[1] += $l.clientHeight;
						}else{
							fixTops[index] = $l.clientHeight;
						}
					}
				});
				maxTop = Math.max.apply(null, fixTops);
			}else{
				this.lists.forEach( ($l, index) => {
					$l.classList.forEach( (className) => {
						if( className.startsWith("u-") ){
							$l.classList.remove(className);
						}
					});
				});
			}
			
			for(let i = 0; i < masonry.tops.length; i++){
				masonry.tops[i] += maxTop;
			}
			//console.log(masonry.tops, maxTop);
			this.lists.forEach( ($l, index) => {
				//最初の2つは固定表示
				let num = index;
				if( hasBigCol2 ){
					num = index - 2;
				}
				let remain = num%masonry.cols;
				if(hasBigCol2){
					if(index < 2){
						$l.style.transform = ``;
					}else{
						setStyle();
					}
				}else{
					//console.log("this way")
					setStyle();
				}
				
				function setStyle(){
					let n = "u-" + remain;
					$l.classList.add(n);
					let t = masonry.tops[remain];
					//console.log(index, t)
					$l.style.transform = `translate3d(0, ${t}px, 0)`;
					let h = $l.clientHeight;
					masonry.tops[remain] += h;
				}
			});
			let maxH = Math.max.apply(null, masonry.tops);
			this.target.style.height = maxH + "px";
		}
	},
	resizeTop: function($target){
		//console.log("masonry init");
		//console.log($target);
		this.target 	= $target;
		this.lists		= $target.querySelectorAll("[data-summary]");
		//console.log(this.lists);
		/*
			2カラム以上はリストの頭2つの高さを取得してからtopを決めるようにする
		*/
		if (window.matchMedia('all and (min-width : 1848px)').matches) {
			masonry.cols = 6;
			masonry.tops = [0, 0, 0, 0, 0, 0];
		}else if (window.matchMedia('all and (min-width : 1564px)').matches) {
			masonry.cols = 5;
			masonry.tops = [0, 0, 0, 0, 0];
		}else if (window.matchMedia('all and (min-width : 1280px)').matches) {
			masonry.cols = 4;
			masonry.tops = [0, 0, 0, 0];
		}else if (window.matchMedia('all and (min-width : 948px)').matches) {
			masonry.cols = 3;
			masonry.tops = [0, 0, 0];
		}else if (window.matchMedia('all and (min-width : 664px)').matches) {
			masonry.cols = 2;
			masonry.tops = [0, 0];
		}else{
			masonry.cols = 1;
			masonry.tops = [0];
		}
		//console.log(masonry.cols, this.lists);
		if(masonry.cols === 1){
			this.target.style.height = "";
			this.lists.forEach( ($l, index) => {
				$l.style.transform = ``;
			});
		}else{
			this.lists.forEach( ($l, index) => {
				$l.classList.forEach( (className) => {
					if( className.startsWith("u-") ){
						$l.classList.remove(className);
					}
				});
			});
			
			//console.log(masonry.tops, maxTop);
			this.lists.forEach( ($l, index) => {
				//最初の2つは固定表示
				let num = index;
				let remain = num%masonry.cols;
				let n = "u-" + remain;
				$l.classList.add(n);
				let t = masonry.tops[remain];
				//console.log(index, t)
				$l.style.transform = `translate3d(0, ${t}px, 0)`;
				let h = $l.clientHeight;
				masonry.tops[remain] += h;
			});
			let maxH = Math.max.apply(null, masonry.tops);
			this.target.style.height = maxH + "px";
		}
		
	}
}